module.exports = __webpack_public_path__ + "static/media/primereact.35f0988d.png";